//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { PrimaryRouteAnchor } from '@components/RouteAnchor';
import { PrimaryLinkButton } from '@components/atoms/button/Button';
import Icon from '@components/atoms/icon/Icon';
import { BodyText } from '@components/atoms/text/Text';
import ReelId from '@models/ReelId';
import { UIATrackingIds } from '@uia/constants/uiaConstants';
import { isDefined } from '@utils/filterPredicates';

export interface EditorDisabledNotesProps {
  isProductTaggingDisabled: boolean;
  onSearchProductCatalog?: () => void;
  reelId: ReelId | undefined;
}

export const EditorDisabledNotes = ({
  isProductTaggingDisabled,
  onSearchProductCatalog,
  reelId,
}: EditorDisabledNotesProps) => {
  return (
    <>
      {isProductTaggingDisabled && (
        <BodyText>
          <Icon name='info' />
          &nbsp; To edit tagged products for this media, use&nbsp;
          {isDefined(reelId) ? (
            <>
              <PrimaryRouteAnchor
                state='galleries'
                stateParams={{ reelId }}
                trackingId={UIATrackingIds.PRODUCTS_REEL_MODERATION}
              >
                gallery moderation.
              </PrimaryRouteAnchor>
            </>
          ) : (
            'gallery moderation.'
          )}
          &nbsp;If you redistribute this media to Scheduler, another Gallery,
          etc., your product tags will not be replicated to the new item.
          Contact your Bazaarvoice Success Manager for more information.
        </BodyText>
      )}
      {!isProductTaggingDisabled && (
        <BodyText>
          Click on the image to tag a spot with a product, or&nbsp;
          <PrimaryLinkButton
            onClick={onSearchProductCatalog}
            trackingId={UIATrackingIds.PRODUCTS_SEARCH_PRODUCT_CATALOG}
            type='button'
          >
            tag the whole image.
          </PrimaryLinkButton>
        </BodyText>
      )}
    </>
  );
};
